import { render, staticRenderFns } from "./LockTokenEditDialog.vue?vue&type=template&id=48dc2376&"
import script from "./LockTokenEditDialog.vue?vue&type=script&lang=js&"
export * from "./LockTokenEditDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports